import { LINKS } from "./constants";

export const getLiteUrl = () => {
  if (process.env.NODE_ENV === "development") {
    return LINKS.LITE_MSP.DEV;
  }
  return LINKS.LITE_MSP.OFFICIAL;
}